import { EventSubscriptionFacade } from '@/usecases/event-bus-for-third-party/subscriber/facade'
import { EventBusForThirdParty } from '../event-bus'
import { handleEveryPageView } from './default/handle-every-page-view'
import { handlePublishDeveloperReports } from './default/handle-publish-developer-reports'
import { handlePurchaseSubscription } from './default/handle-purchase-subscription'
import { handleCartViewEvent } from './hotellovers/handle-cart-view'
import { handlePageInitializedEvent } from './hotellovers/handle-page-initialized'
import { handleProductDetailViewEvent } from './hotellovers/handle-product-detail-view'
import { handlePurchase } from './hotellovers/handle-purchase'

export class HotelloversEventSubscriptionFacade implements EventSubscriptionFacade {
  constructor() {
    /** GAで使用するdataLayerがundefinedでないことを保証する。 */
    window.dataLayer = window.dataLayer || []
  }

  subscribeAll(): void {
    const eventBus = EventBusForThirdParty.getInstance()
    eventBus.subscribe('product-detail-view', handleProductDetailViewEvent)
    eventBus.subscribe('cart-view', handleCartViewEvent)
    eventBus.subscribe('purchase', handlePurchase)
    eventBus.subscribe('page-initialized', handlePageInitializedEvent)
    // default GTM events
    eventBus.subscribe('every-page-view', handleEveryPageView)
    eventBus.subscribe('purchase-subscription', handlePurchaseSubscription)
    eventBus.subscribe('publish-developer-reports', handlePublishDeveloperReports)
  }
}
